export const RESTORE_RESULTS_TABLE = {
  headers: ['order', 'result'],
} as const;
